import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

function Escprofile() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [error, setError] = useState("");

  // Get current user info from cookie
  const userCookie = Cookies.get("user");
  const currentUser = userCookie ? JSON.parse(userCookie) : null;
  const isLoggedIn = !!Cookies.get("authToken");

  // Fetch user and reviews
  const fetchUser = () => {
    fetch(`${process.env.REACT_APP_API_URL}/${id}`)
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) {
          setUser(data[0]);
        } else if (data.error) {
          setError(data.error);
        } else {
          setError("User not found");
        }
      })
      .catch((err) => {
        console.error("Fetch error:", err);
        setError("Failed to load user");
      });
  };

  useEffect(() => {
    fetchUser();
  }, [id]);

  const handleLeaveReview = () => {
    if (!isLoggedIn) {
      if (window.confirm("You need to log in or register to leave a review. Go to login page?")) {
        navigate("/login"); // redirect to login page
      }
      return;
    }
    navigate(`/review/${id}`);
  };

  const handleEditReview = (reviewId) => {
    navigate(`/edit-review/${id}/${reviewId}`);
  };

  const handleDeleteReview = async (reviewId) => {
    if (!window.confirm("Are you sure you want to delete this review?")) return;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/delete-review/${reviewId}`,
        { method: "DELETE" }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed to delete review");
      }

      // Refresh user data to remove deleted review from UI
      fetchUser();
    } catch (err) {
      alert(`❌ ${err.message}`);
    }
  };

  if (error) return <p style={{ color: "red" }}>{error}</p>;
  if (!user) return <p>Loading...</p>;

  const userHasReviewed =
    isLoggedIn &&
    user.reviews?.some((review) => review.user_email === currentUser?.email);

  return (
    <div style={{ padding: "20px" }}>
      <h2>{user.name}'s Reviews</h2>

      {(!user.reviews || user.reviews.length === 0) ? (
        <div>
          <h3>No reviews found.</h3>
          <button
            onClick={handleLeaveReview}
            style={{
              marginTop: "15px",
              padding: "10px 16px",
              backgroundColor: "#1976d2",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Leave a Review
          </button>
        </div>
      ) : (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
          {user.reviews.map((review, index) => (
            <div
              key={review.review_id || index}
              style={{
                border: "1px solid #ccc",
                borderRadius: "8px",
                padding: "10px",
                width: "250px",
                backgroundColor: "#fdfdfd",
                position: "relative",
              }}
            >
              <p>
                <strong>Reviewer:</strong>{" "}
                {review.user_email ? review.user_email.split("@")[0] : "Anonymous"}
              </p>
              <p>
                <strong>Attitude:</strong> {review.attitude}
              </p>
              <p>
                <strong>Comment:</strong> {review.comment}
              </p>
              <p>
                <strong>Date:</strong> {review.date}
              </p>
              <p>
                <strong>Looks:</strong> {review.looks}
              </p>
              <p>
                <strong>Rating:</strong> {review.rating}
              </p>
              <p>
                <strong>Value:</strong> {review.value}
              </p>

              {currentUser && review.user_email === currentUser.email && (
                <div style={{ display: "flex", gap: "5px", marginTop: "10px" }}>
                  <button
                    onClick={() => handleEditReview(review.review_id || index)}
                    style={{
                      padding: "6px 12px",
                      backgroundColor: "#ffa000",
                      color: "#fff",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    Edit Review
                  </button>
                  <button
                    onClick={() => handleDeleteReview(review.review_id)}
                    style={{
                      padding: "6px 12px",
                      backgroundColor: "#d32f2f",
                      color: "#fff",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    Delete Review
                  </button>
                </div>
              )}
            </div>
          ))}

          {/* Leave Review button */}
          {!userHasReviewed && (
            <button
              onClick={handleLeaveReview}
              style={{
                marginTop: "15px",
                padding: "10px 16px",
                backgroundColor: "#1976d2",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                height: "40px",
                alignSelf: "start",
              }}
            >
              Leave a Review
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default Escprofile;
